import {ReactiveService} from './reactive-service.abstract';
import {ActivatedRouteSnapshot, Params} from '@angular/router';
import {isArray} from 'util';

export abstract class ReactiveServiceWithFilters extends ReactiveService {
  protected filters: { [key: string]: string } = {};

  protected constructor() {
    super();
    this.initFilters();
  }

  protected _params: Params = {};

  get params() {
    return this._params;
  }
  set params(newValue) {
    this._params = newValue;
  }

  protected _queryParams: Params = {};

  get queryParams() {
    return this._queryParams;
  }
  set queryParams(newValue) {
    this._queryParams = newValue;
  }


  protected _options: Params = {};

  get options() {
    return this._options;
  }
  set options(newValue) {
    this._options = newValue;
  }

  protected initFilters() {
    this.filters = {};
  }

  setOptions(options: object): ReactiveServiceWithFilters {
    this.options = {...this.options, ...options};
    return this;
  }

  setParams(params: object, force = false): ReactiveServiceWithFilters {
    if (force) {
      this.params = {...params};
    } else {
      this.params = {...this.params, ...params};
    }
    return this;
  }

  protected buildUrl(baseUrl: string, defaultUrl = '') {
    let filtersStr = this.buildFilters().join('/');
    if (filtersStr.substring(0, 1) === '/') {
      filtersStr = filtersStr.substring(1);
    }
    const optionsStr = this.buildOptions().join('&');
    const optionsQuery = optionsStr ? '?' + optionsStr : '';
    return filtersStr ? `${baseUrl}/${filtersStr}${optionsQuery}` : `${baseUrl}${defaultUrl}${optionsQuery}`;
  }

  protected buildOptions(): string[] {
    const joinArrayKeys = (_key, lst: string[] | string): string => {
      if (!Array.isArray(lst)) {
        return joinArrayKeys(_key, [lst]);
      }
      return lst.map(_value => `${_key}=${_value}`).join('&');
    };

    return Object
      .keys(this.options)
      .filter(_key => this.options[_key] !== undefined)
      .map(_key => joinArrayKeys(_key, this.options[_key])
      ).filter(_key => _key !== '');
  }

  protected buildFilters(): string[] {
    return Object
      .keys(this.params)
      .map(_key => this.filters[_key]
        ? this.filters[_key].replace(':value', this.params[_key])
        : null
      ).filter(_key => _key !== null && _key !== '');
  }

  protected setFilterParams(route: ActivatedRouteSnapshot) {
    if (!route.data.options || !route.data.options.filterIdList) {
      return;
    }
    route.data.options.filterIdList.forEach(_key => {
      if (route.params[_key]) {
        this.params[_key] = route.params[_key];
      }
    });
  }

  protected setQueryParams(route: ActivatedRouteSnapshot): void {
    if (route.queryParams && Object.keys(route.queryParams).length > 0) {
      this.queryParams = route.queryParams;
    }
  }
}
